import { useState } from "react";
import { Input } from "antd";
import React from "react";
import { TextService } from "../../Services/TextService";

// Google Places suggestions are disabled - the location is a plain free-text field.
export const GooglePlaceAutoComplete = (props: any) => {
    const GetText = TextService.GetText;
    const [value, setValue] = useState("");

    React.useEffect(() => {
        if (props.defaultValue) {
            setValue(props.defaultValue);
        }
    }, [props.defaultValue]);

    return (
        <div style={{ width: "100%" }}>
            <Input
                style={{ color: "black" }}
                value={value}
                placeholder={GetText("GooglePlaceAutoComplete_Placeholder")}
                onChange={(evt) => {
                    setValue(evt.target.value);
                    props.onPlaceSelected(evt.target.value);
                }}
            />
        </div>
    );
};
